// removed by extract-text-webpack-plugin
module.exports = {"orderItem":"_9gaSV","right":"Wm1he","photo":"_2cvlC","details":"_27BxS","quantity":"gRN3S","buyAgainButton":"_2FdQ6","left":"A2JA6","name":"_2hjoC","variantPriceLine":"_3kEVm","total":"_1FS0v"};


//////////////////
// WEBPACK FOOTER
// ./banquet/components/OrderItemTile/index.sass
// module id = 1490
// module chunks = 1